import { gql, useMutation } from 'urql';

export const UPDATE_USER = gql`
  mutation UpdateEmployee($participantId: Int!, $input: UpdateParticipant!) {
    updateParticipant(participantId: $participantId, input: $input) {
      errorData {
        firstName
        lastName
        phone
        email
        errorText
      }
    }
  }
`;

export interface UpdateEmployeeVariables {
  participantId?: number;
  input: {
    email: string;
    phone: string;
    firstName: string;
    lastName: string;
  };
}

export interface ErrorData {
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  errorText?: string;
}

export interface UpdateEmployeeResponse {
  updateParticipant: {
    errorData?: ErrorData | null;
  };
}

export const useUpdateUser = () => {
  const [{ data, error }, executeMutation] = useMutation<UpdateEmployeeResponse, UpdateEmployeeVariables>(UPDATE_USER);

  const updateUser = (input: UpdateEmployeeVariables) => {
    return executeMutation(input);
  };

  return { data, error, updateUser };
};
